import { createSelector } from 'reselect';
import _get from 'lodash/get';

import { getPromotedSite } from '../utils';


export const getSelectedParams = state => (
  state.affiliateTools.selectedParams
);
export const getAffiliateToolsFilterStructure = state => (
  state.affiliateTools.affiliateToolsFilterStructure
);
export const getAffiliateToolsFilterParams = createSelector(
  getSelectedParams,
  getAffiliateToolsFilterStructure,
  ({ site, type }, affiliateToolsFilterStructure) => (
    _get(affiliateToolsFilterStructure, [getPromotedSite(site), type])
  )
);
export const getIsAffiliateToolsFilterStructureLoading = state => (
  state.affiliateTools.isAffiliateToolsFilterStructureLoading
);
export const getLaunchAffiliateToolUrl = state => (
  state.affiliateTools.launchAffiliateToolUrl
);
export const getAffiliateTools = state => (
  _get(state, `affiliateTools.affiliateToolsByType.${getSelectedParams(state).type}`)
);
export const getAffiliateToolsOrder = state => (
  _get(state, `affiliateTools.affiliateToolsOrderByType.${getSelectedParams(state).type}`)
);
export const getIsAffiliateToolsLoading = state => (
  state.affiliateTools.isAffiliateToolsLoading
);
export const getRequestStartTime = state => (
  state.affiliateTools.requestStartTime
);
export const getPromotedSites = state => (
  state.affiliateTools.promotedSites
);
export const getPromotedSiteName = (state, site) => (
  _get(getPromotedSites(state), [site, 'name'])
);
export const getPromotedSiteAvailableLangs = (state, site) => (
  _get(getPromotedSites(state), [site, 'availableLangs'])
);
export const getRotatingBanner = state => (
  state.affiliateTools.rotatingBanner
);
export const getAffiliateToolContent = (state, id) => (
  state.affiliateTools.affiliateToolContentById[id]
);
export const getCustomBanners = state => (
  state.affiliateTools.customBanners
);
export const getCustomBanner = (state, bannerId) => (
  _get(getCustomBanners(state), bannerId)
);

export const getAffiliateToolsFilterStructureError = state => (
  state.affiliateTools.errors.getAffiliateToolsFilterStructureError
);
export const getAffiliateToolsError = state => (
  state.affiliateTools.errors.getAffiliateToolsError
);
export const getRotatingBannerError = state => (
  state.affiliateTools.errors.getRotatingBannerError
);
export const getAffiliateToolContentError = (state, affiliateToolId) => (
  state.affiliateTools.errors.getContentError[affiliateToolId]
);
export const getCustomBannersError = state => (
  state.affiliateTools.errors.getCustomBannersError
);
export const getCreateCustomBannerError = state => (
  state.affiliateTools.errors.createCustomBannerError
);
export const getEditCustomBannerError = state => (
  state.affiliateTools.errors.editCustomBannerError
);
export const getDeleteCustomBannerError = state => (
  state.affiliateTools.errors.deleteCustomBannerError
);
